// GA4 event helpers (gtag.js is loaded sitewide in public/index.html).

// Fires the GA4 "generate_lead" conversion event after a successful quote submission.
export const trackGenerateLead = () => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', { form_name: 'phquote_submission' });
  }
};
